var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.visible
        ? _c(
            "bj-modal",
            {
              attrs: {
                size: "sm",
                title: (_vm.payload.id ? "Edit" : "Add") + "  Devices"
              },
              model: {
                value: _vm.visible,
                callback: function($$v) {
                  _vm.visible = $$v
                },
                expression: "visible"
              }
            },
            [
              _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _c("div", { staticClass: "row gutter-xs" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c(
                        "q-field",
                        [
                          _c("autocomplete", {
                            attrs: {
                              method: "autocompleteBusiness",
                              placeholder: "Business..."
                            },
                            on: {
                              change: _vm.businessSelected,
                              clear: function($event) {
                                _vm.payload.business_id = null
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12 mt-3" },
                    [
                      _c(
                        "q-field",
                        [
                          _c("q-select", {
                            attrs: {
                              "float-label": "Provider",
                              options: _vm.providersOptions
                            },
                            model: {
                              value: _vm.payload.provider,
                              callback: function($$v) {
                                _vm.$set(_vm.payload, "provider", $$v)
                              },
                              expression: "payload.provider"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12 mt-3" },
                    [
                      _c(
                        "q-field",
                        [
                          _c("q-input", {
                            attrs: {
                              type: "textarea",
                              rows: _vm.payload.id ? 1 : 5,
                              "float-label": "Serial Numbers"
                            },
                            model: {
                              value: _vm.payload.serial_numbers,
                              callback: function($$v) {
                                _vm.$set(_vm.payload, "serial_numbers", $$v)
                              },
                              expression: "payload.serial_numbers"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  !_vm.isProd
                    ? _c(
                        "div",
                        { staticClass: "col-12 mt-3" },
                        [
                          _c(
                            "q-field",
                            [
                              _c("q-toggle", {
                                attrs: { label: "Is Real Device" },
                                model: {
                                  value: _vm.payload.is_real,
                                  callback: function($$v) {
                                    _vm.$set(_vm.payload, "is_real", $$v)
                                  },
                                  expression: "payload.is_real"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "col-12 row justify-end" },
                    [
                      _c("q-btn", {
                        staticClass: "q-mr-lg",
                        attrs: {
                          rounded: "",
                          size: "md",
                          color: "grey",
                          label: "Cancel"
                        },
                        on: { click: _vm.close }
                      }),
                      _c("q-btn", {
                        attrs: {
                          rounded: "",
                          size: "md",
                          color: "primary",
                          label:
                            "" +
                            (_vm.payload.id ? "Edit Device" : "Add Devices")
                        },
                        on: { click: _vm.addDevice }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }